import BaseService from "./BaseService.js";

class FormsService extends BaseService {
	get(query) {
		return this.apiGet({
			url: "/forms",
			params: query,
		});
	}

	getDoc() {
		return this.apiGet({
			url: "/forms/doc",
		});
	}

	getValue() {
		return this.apiGet({
			url: '/form',
		});
	}

	submit(payload) {
		return this.apiPost({
			url: '/form',
			data: payload,
		})
	}
}

export default new FormsService();
